// Use the selected company membership returned by the server, never the global user/JWT role.
const memberRoles=new Set(['admin','analyst','viewer']);
export const CUSTOMER_PAGES={
 '/dashboard':'personal','/alerts':'personal','/reports':'personal',
 '/settings':'personal','/profile-settings':'personal','/support':'personal',
 '/incidents':'member','/responses':'member','/gateways':'member',
 '/devices':'member','/ingestions':'member','/syslog':'member','/admin':'admin',
};
export function canCustomerPage(organization,path) {
 const key=path.startsWith('/admin/')?'/admin':path;
 const access=CUSTOMER_PAGES[key];
 if(access==='personal')return true;
 if(!organization?.guid || !memberRoles.has(organization.membership_role))return false;
 return access==='member' || (access==='admin'&&organization.membership_role==='admin');
}
export function canCustomerFeature(organization,feature) {
 if(!organization?.guid || !memberRoles.has(organization.membership_role))return false;
 if(feature==='case.edit')return ['admin','analyst'].includes(organization.membership_role);
 return ['response.manage','gateway.enroll','deadline.manage','organization.manage'].includes(feature) && organization.membership_role==='admin';
}
export function customerResponseTabs(organization) {
 const tabs=[['queue','Responses'],['audit','Audit']];
 if(!canCustomerFeature(organization,'response.manage'))return tabs;
 return [['queue','Responses'],['policy','Policy'],['autonomy','Autonomy'],['safety','Safety'],['playbooks','Playbooks'],['allowlist','Allowlist'],['audit','Audit']];
}
